import prj1 from '../images/project/1.jpg'
import prj2 from '../images/project/2.jpg'
import prj3 from '../images/project/3.jpg'
import prj4 from '../images/project/4.jpg'
import prj5 from '../images/project/5.jpg'
import prj6 from '../images/project/6.jpg'

import prwj1 from '../images/project/7.jpg'
import prwj2 from '../images/project/11.jpg'
import prwj3 from '../images/project/9.jpg'
import prwj4 from '../images/project/10.jpg'
import prwj5 from '../images/project/8.jpg'

import propj1 from '../images/project/12.jpg'
import propj2 from '../images/project/13.jpg'
import propj3 from '../images/project/14.jpg'
import propj4 from '../images/project/15.jpg'
import propj5 from '../images/project/16.jpg'

import prontj1 from '../images/project/17.jpg'
import prontj2 from '../images/project/19.jpg'
import prontj3 from '../images/project/20.jpg'
import prontj4 from '../images/project/21.jpg'
import prontj5 from '../images/project/22.jpg'
import prontj6 from '../images/project/18.jpg'

import primg1 from '../images/project-single/2.jpg'
import primg2 from '../images/project-single/3.jpg'

import prwimg1 from '../images/project-single/4.jpg'
import prwimg2 from '../images/project-single/5.jpg'

import propimg1 from '../images/project-single/6.jpg'
import propimg2 from '../images/project-single/7.jpg'

import pront1 from '../images/project-single/nt1.jpg'
import pront2 from '../images/project-single/nt2.jpg'

import halafyBanner from '../images/halalfy-banner.jpg'


const Projects = [
   {
     id:'halalfy',
     projectImg:halafyBanner,
     title:"Halalfy",
     dec:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
     prImg1:halafyBanner,
     prImg2:halafyBanner,
     description:"Discovering financial freedom with the Halalfy app. Through our Halalfy app scholars of the Shariah board are dedicated to educating individuals on how to safeguard themselves from interest-based loans and raising awareness about where interest is involved in business and employment. With our comprehensive programs, you'll gain valuable insights and practical knowledge to navigate the complex world of finance while adhering to Islamic principles. Join us on this empowering journey towards financial independence and secure a brighter future for yourself and your loved ones.",
   },
]

export default Projects;